import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import PartyPickDialog from "@/components/PartyPickDialog";
import LiveNotifier from "@/components/LiveNotifier";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AuthModal />
      <PartyPickDialog />
      <LiveNotifier />
    </div>
  );
}
